import c from "../common";

export default {
  description_1: "Request",
  description_2: c.vendor.en.uppercase,
  description_3: c.voucher.en.uppercase + " & " + c.discount.en.uppercase,
  billing: "Billing Report",
  export: "Export",
  price: "Price",
  voucher: "Voucher",
  qty: "Quantity",
  total: "Total Price",
  vendor: "Vendor",
  recordID: "Record ID"
};
